import PropTypes from 'prop-types';
import { Navigate } from 'react-router-dom';
// routes
import { paths } from 'src/routes/paths';
// api
import { useGetPatient } from 'src/api/patients';
import { useGetAIProcessingResults } from 'src/api/ai-processing';
// utils
import { getClaimFlowAccess } from 'src/utils/claim-flow-access';

// ----------------------------------------------------------------------

export default function ClaimFlowGuard({ step, children }) {
  const patientId = typeof window !== 'undefined' ? sessionStorage.getItem('patientToken') : null;
  const { patient, patientLoading } = useGetPatient(patientId);
  const claimId = patient?.claimId;
  const { results: aiResults, resultsLoading } = useGetAIProcessingResults(claimId);

  const access = getClaimFlowAccess({ patientId, patient, aiResults });
  const isAllowed = Boolean(access.canAccess[step]);

  const needsAiResults =
    step === 'policyCoverage' ||
    step === 'aiVerification' ||
    step === 'approvalWorkflow' ||
    step === 'finance' ||
    step === 'claimClosure';

  if (patientLoading || (needsAiResults && claimId && resultsLoading)) {
    return null;
  }

  if (!isAllowed) {
    const fallback = access.hasPatient
      ? paths.dashboard.claim.documentCollection
      : paths.dashboard.claim.allPatients;
    return <Navigate to={fallback} replace />;
  }

  return <>{children}</>;
}

ClaimFlowGuard.propTypes = {
  step: PropTypes.oneOf([
    'documentCollection',
    'aiProcessing',
    'policyCoverage',
    'aiVerification',
    'approvalWorkflow',
    'finance',
    'claimClosure',
  ]).isRequired,
  children: PropTypes.node,
};

